import ENDPOINTS from "@/lib/endpoints";
import { useState, useEffect } from "react";

const useFooterMenu = () => {
    const [footerMenus, setFooterMenus] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFooterMenus = async () => {
            try {
                const res = await fetch(
                    `${process.env.NEXT_PUBLIC_API_URL}${ENDPOINTS.FOOTER_MENUS}`
                );

                if (!res.ok) throw new Error("Failed to fetch footer menus");
                const data = await res.json();
                setFooterMenus(data.menus || []);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchFooterMenus();
    }, []);

    return { footerMenus, loading, error };
};

export default useFooterMenu;
